import { useState } from "react";
import PageHeader from "./PageHeader";
import { useSiteContent } from "../../context/SiteContext";
import { Headphones as HeadphonesIcon } from "lucide-react";

export default function Headphones() {
  const content = useSiteContent();
  const playlists = content.playlists || [];
  const [active, setActive] = useState(playlists[0]?.id);
  const current = playlists.find((p) => p.id === active) || playlists[0];

  return (
    <div data-testid="page-headphones">
      <PageHeader
        code="02"
        label="HEADPHONES"
        title="Headphones"
        subtitle="A direct line into the catalog. Pick a transmission, plug in, listen at volume."
      />

      {!current ? (
        <section>
          <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 text-center">
            <p className="label-mono text-neutral-500">// no channels loaded</p>
          </div>
        </section>
      ) : (
      <section>
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12 grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Player */}
          <div className="lg:col-span-2">
            <div
              data-testid="spotify-player-frame"
              className="em-card p-3 relative"
              style={{ boxShadow: "0 0 40px rgba(0,255,106,0.07)" }}
            >
              <div className="flex items-center justify-between px-3 py-2 border-b border-[#27272A]">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-neon animate-pulse" />
                  <span className="label-mono text-neon">NOW PLAYING</span>
                </div>
                <HeadphonesIcon size={16} className="text-neutral-500" />
              </div>
              <div className="mt-3">
                {current.platform === "soundcloud" ? (
                  <iframe
                    data-testid="soundcloud-iframe"
                    title={current.title}
                    src={current.embedUrl}
                    width="100%"
                    height="350"
                    frameBorder="0"
                    allow="autoplay"
                    loading="lazy"
                    style={{ border: 0 }}
                  />
                ) : (
                  <iframe
                    data-testid="spotify-iframe"
                    title={current.title}
                    src={current.embedUrl}
                    width="100%"
                    height="480"
                    frameBorder="0"
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                    loading="lazy"
                    style={{ border: 0 }}
                  />
                )}
              </div>
            </div>
          </div>

          {/* Playlist Selector */}
          <aside>
            <div className="label-mono text-neutral-500 mb-3">// channels</div>
            <ul className="flex flex-col gap-3">
              {playlists.map((p) => {
                const isActive = p.id === active;
                return (
                  <li key={p.id}>
                    <button
                      data-testid={`playlist-${p.id}`}
                      onClick={() => setActive(p.id)}
                      className={`em-card w-full text-left p-4 flex items-center justify-between ${
                        isActive ? "!border-neon" : ""
                      }`}
                    >
                      <div>
                        <div className="font-display font-bold text-sm">{p.title}</div>
                        <div className="label-mono text-neutral-500 mt-1">
                          {isActive ? "● ACTIVE" : "○ STANDBY"}
                        </div>
                      </div>
                      <span
                        className={`label-mono ${
                          isActive ? "text-neon" : "text-neutral-500"
                        }`}
                      >
                        {String(playlists.indexOf(p) + 1).padStart(2, "0")}
                      </span>
                    </button>
                  </li>
                );
              })}
            </ul>
            <p className="text-neutral-500 text-xs mt-6 label-mono">
              // {playlists.length} channel{playlists.length !== 1 ? "s" : ""} loaded
            </p>
          </aside>
        </div>
      </section>
      )}
    </div>
  );
}
